import { Cell } from "./Cell.js";
import { Multiline } from "./Multiline.js";
import { TwinContainer } from "./TwinContainer.js";
const InputFields = {
  Cell,
  TwinContainer,
  Multiline
};
export {
  InputFields
};
